import axios from 'axios';
const instance = axios.create({
  
   //Offline
  // baseURL : 'http://127.0.0.1:8000/api/'

   //Online
   baseURL : 'https://dmsapi.businesssamadhan.in/public/api/'


});
export default instance;